import React from 'react';

import { Controller, useFormContext, useFormState } from 'react-hook-form';

import { Colors } from '@theme/index';
import Card from '@components/elements/Card';
import InputTextarea from '@components/elements/InputTextarea';
import InputNumber from '@components/elements/InputNumber';
import InputText from '@components/elements/InputText';
import NewImagePickerButton from '@components/elements/ImagePickerButton/new';
import { CreatePollData } from '../types';

const colors = ['orange'];

const PollCreateQuestionOptionCard: React.FC<{
  id: string;
  questionIndex: number;
  index: number;
  onRemove: () => void;
  className?: string;
  register: any;
  control: any;
  hideResponse?: boolean;
  pledging?: boolean;
  neon?: string;
}> = ({
  id,
  questionIndex,
  index,
  onRemove,
  className,
  neon,
  register,
  control,
  hideResponse = false,
  pledging = false,
}) => {
  const { getValues } = useFormContext<CreatePollData>();

  const { errors } = useFormState({
    name: `questions.${questionIndex}.options.${index}` as const,
  });

  return (
    <div className={className} style={{ marginTop: '6rem' }}>
      {neon && (
        <h4 style={{ color: neon }} className="mb-2 font-bold">{`RESPONSE ${
          index + 1
        }`}</h4>
      )}

      <Card
        neon={neon}
        title={neon ? undefined : `RESPONSE ${index + 1}`}
        bgColor="white"
        shadowColor={colors[Math.floor(Math.random() * colors.length)]}
        accessory={
          <div className="w-full flex flex-item justify-end">
            <div style={{ width: 20, height: 20 }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                className="cursor-pointer"
                onClick={onRemove}
              >
                <path
                  fill={neon}
                  stroke="red"
                  className="fa-primary"
                  d="M163.8 0c-12.1 0-23.2 6.8-28.6 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8z"
                />
                <path
                  stroke={neon}
                  strokeWidth={20}
                  className="fa-secondary"
                  d="M394.6 466.8L416 96H32L53.4 466.8c1.5 25.4 22.5 45.2 47.9 45.2H346.7c25.4 0 46.5-19.8 47.9-45.2z"
                />
              </svg>
            </div>

            {/* <button
              type="button"
              style={{ color: neon || 'red' }}
              className={`font-bold text-opacity-50 select-none  font-display focus:outline-none`}
              onClick={onRemove}
            >
              REMOVE
            </button> */}
          </div>
        }
      >
        <div className=" py-4 space-y-4">
          {!hideResponse && (
            <Controller
              name={
                `questions.${questionIndex}.options.${index}.title` as const
              }
              defaultValue={getValues(
                `questions.${questionIndex}.options.${index}.title` as const
              )}
              render={({ field }) => (
                <InputText
                  neon={neon}
                  type="text"
                  borderColor={Colors['gray-dark']}
                  shadow={false}
                  placeholder="Title*"
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
          )}

          {!hideResponse &&
            errors.questions?.[questionIndex]?.options?.[index]?.title
              ?.message && (
              <div className="flex justify-end px-2 text-sm font-semibold text-red">
                {
                  errors.questions?.[questionIndex]?.options?.[index]?.title
                    ?.message
                }
              </div>
            )}
          <Controller
            name={
              `questions.${questionIndex}.options.${index}.description` as const
            }
            defaultValue={getValues(
              `questions.${questionIndex}.options.${index}.description` as const
            )}
            render={({ field }) => (
              <InputTextarea
                neon={neon}
                placeholder="Description"
                className="p-1 border-none"
                rows={3}
                max={80}
                limitMax
                preventMultiline
                value={field.value}
                onChange={field.onChange}
              />
            )}
          />
          {errors.questions?.[questionIndex]?.options?.[index]?.description
            ?.message && (
            <div className="flex justify-end px-2 text-sm font-semibold text-red">
              {
                errors.questions?.[questionIndex]?.options?.[index]?.description
                  ?.message
              }
            </div>
          )}

          <div className="space-y-1">
            <div className="flex space-x-4">
              <Controller
                name={
                  `questions.${questionIndex}.options.${index}.embed` as const
                }
                defaultValue={getValues(
                  `questions.${questionIndex}.options.${index}.embed` as const
                )}
                render={({ field }) => (
                  <InputText
                    neon={neon}
                    type="text"
                    borderColor={Colors['gray-dark']}
                    shadow={false}
                    placeholder="Embed video link"
                    value={field.value}
                    onChange={field.onChange}
                  />
                )}
              />

              <Controller
                name={
                  `questions.${questionIndex}.options.${index}.image` as const
                }
                defaultValue={getValues(
                  `questions.${questionIndex}.options.${index}.image` as const
                )}
                control={control}
                render={({ field }) => {
                  return (
                    <NewImagePickerButton
                      value={field.value}
                      onChange={(file) => {
                        field.onChange(file);

                        // form.setValue(
                        //   `questions.${questionIndex}.options.${index}.image` as const,
                        //   file
                        // );
                        // if (!file) {
                        //   form.setValue(
                        //     `questions.${questionIndex}.options.${index}.removeImage` as const,
                        //     true
                        //   );
                        // } else {
                        // }
                      }}
                      length={1}
                    />
                  );
                }}
              />
            </div>
            {errors.questions?.[questionIndex]?.options?.[index]?.embed
              ?.message && (
              <div className="flex justify-start px-2 text-sm font-semibold text-red">
                {
                  errors.questions?.[questionIndex]?.options?.[index]?.embed
                    ?.message
                }
              </div>
            )}
          </div>

          {pledging && (
            <Controller
              name={
                `questions.${questionIndex}.options.${index}.price` as const
              }
              defaultValue={getValues(
                `questions.${questionIndex}.options.${index}.price` as const
              )}
              control={control}
              render={({ field }) => {
                return (
                  <InputNumber
                    type="currency"
                    value={field.value}
                    onChange={(v) => {
                      field.onChange(v);
                    }}
                    onBlur={field.onBlur}
                    decimalScale={2}
                    allowNegative={false}
                    thousandSeparator={true}
                    prefix={'$'}
                    borderColor={Colors['gray-dark']}
                    shadow={false}
                    neon={neon}
                    placeholder="Pledge amount*"
                  />
                );
              }}
            />
          )}
          {/* {pledging && (
                <InputNumber
                  type="currency"
                  decimalScale={2}
                  allowNegative={false}
                  thousandSeparator={true}
                  prefix={'$'}
                  borderColor={Colors['gray-dark']}
                  shadow={false}
                  placeholder="Pledge amount"
                  {...register(
                    `questions.${questionIndex}.options.${index}.price` as const
                  )}
                />
              )} */}
        </div>
      </Card>
    </div>
  );
};

export default PollCreateQuestionOptionCard;
